export default __webpack_public_path__ + "78ceeceecf928ead9e1d270f8eaac684.png";